module.exports = __webpack_public_path__ + "img/upload-s1.25b7fe43.svg";